import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import Milestones from './components/Milestones';
import WhyChooseUs from './components/WhyChooseUs';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import { siteConfig } from '@/mocks/site-config';

export default function AboutPage() {
  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "51吃瓜官网的内容来源是否可靠？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "我们的内容全部来自专业团队的原创调查和多源交叉验证。每一篇爆料在发布前，都需要经过编辑、审核、事实核查三道流程。",
        },
      },
      {
        "@type": "Question",
        "name": "51吃瓜莫里秀是独立栏目吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "是的，51吃瓜莫里秀是我们旗下的王牌调查栏目，专注于深度娱乐调查报道。",
        },
      },
      {
        "@type": "Question",
        "name": "如何向51吃瓜投稿或提供爆料线索？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "您可以通过爆料邮箱 hello@pxkblfc.cn 或在线留言表单提交信息。所有爆料人的身份信息将被严格保密。",
        },
      },
      {
        "@type": "Question",
        "name": "网站的内容更新频率是怎样的？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "我们保持7x24小时全天候更新，每天至少发布5-8篇原创内容。",
        },
      },
      {
        "@type": "Question",
        "name": "51吃瓜官网是否收费？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "目前所有内容免费向公众开放，无需注册即可浏览。",
        },
      },
    ],
  };

  return (
    <>
      <Header />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "51吃瓜官网",
          "url": siteConfig.url,
          "description": siteConfig.description,
          "slogan": siteConfig.slogan,
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "email": "hello@pxkblfc.cn",
            "availableLanguage": ["Chinese"],
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "北京",
            "addressRegion": "朝阳区",
            "streetAddress": "望京SOHO T1 15层",
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": `关于我们 - ${siteConfig.name}`,
          "description": `了解51吃瓜官网的品牌故事、团队背景、用户口碑和联系方式。吃瓜无罪，八卦有理。`,
          "url": `${siteConfig.url}/about`,
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": siteConfig.url },
              { "@type": "ListItem", "position": 2, "name": "关于我们", "item": `${siteConfig.url}/about` },
            ],
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(faqStructuredData)}
      </script>

      <main className="pt-16">
        <AboutHero />
        <BrandStory />
        <Milestones />
        <WhyChooseUs />
        <Reputation />
        <ContactSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}